import SearchResultsContainer from './SearchResultsContainer'

export default SearchResultsContainer
